import React from 'react';
import { useSelector } from 'react-redux';
import Loading from 'components/World/Loading';
import StuckLoadingOverlay from 'components/World/StuckLoadingOverlay';

/**
 * Global loading overlay that renders at the App level.
 * This ensures it appears above ALL other components including
 * SpeechToTextService/LiveKitTextInput which are also at the App level.
 */
const GlobalLoadingOverlay = () => {
  const worldLoading = useSelector(state => state.world.worldLoading);

  return (
    <>
      <Loading loading={worldLoading} />
      {/* Escape hatch for a load that freezes without ever flagging a failure.
          An outright connection failure is handled by ConnectionFailureOverlay
          instead. Never triggered by a slow-but-progressing load. */}
      <StuckLoadingOverlay />
    </>
  );
};

export default GlobalLoadingOverlay;
